/**
 * 控制台外壳。移动端是硬要求(§6b):
 * 侧边栏在 <lg 收成抽屉,主区不再留 56 的左边距,页面本身永不横向滚动。
 */
import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '@/components/feature/Sidebar';
import TopBar from '@/components/feature/TopBar';
import EmergencyStop from '@/components/feature/EmergencyStop';

export default function Layout() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();

  // 换页就收起抽屉 —— 否则手机上点完导航还挡着内容
  useEffect(() => { setDrawerOpen(false); }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background-50 overflow-x-hidden">
      <Sidebar open={drawerOpen} onClose={() => setDrawerOpen(false)} />
      <TopBar onMenu={() => setDrawerOpen(true)} />
      <main className="lg:ml-56 pt-14 min-h-screen">
        <Outlet />
      </main>
      <EmergencyStop />
    </div>
  );
}
